import React from "react";

export default function ColumnSettings({ columns, setColumns }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <strong>Customize Columns:</strong>
      {Object.keys(columns).map(col => (
        <label key={col} style={{ marginLeft: 12 }}>
          <input
            type="checkbox"
            checked={columns[col]}
            onChange={e => setColumns(c => ({ ...c, [col]: e.target.checked }))}
          />
          {col}
        </label>
      ))}
    </div>
  );
}